import styled from "styled-components";
import { LETTER_SPACING, MEDIA_MOBILE_BREAKPOINT } from "src/apps/config/constants";

export const Text = styled.p<{ $color?: string }>`
  color: ${({ $color, theme }) => ($color ? $color : theme.blackColor)};
  font-family: ${({ theme }) => theme.fontFamily};
  font-style: normal;
  font-size: ${({ theme }) => theme.fontSize / 16}rem;
  font-weight: 400;
  line-height: 1.313rem;
  letter-spacing: ${LETTER_SPACING};
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    font-size: 0.875rem;
  }
`;

export const Header1 = styled(Text)`
  font-family: ${({ theme }) => theme.fontFamilyHeadings};
  font-size: 1.75rem;
  line-height: 1.875rem;
  font-weight: 700;
  letter-spacing: -0.0256rem;
`;

export const Header2 = styled(Text)`
  font-family: ${({ theme }) => theme.fontFamilyHeadings};
  font-size: 1.25rem;
  font-weight: 500;
`;

export const Header3 = styled(Text)`
  font-family: ${({ theme }) => theme.fontFamilyHeadings};
  font-size: 1.125rem;
  font-weight: 500;
`;

export const TextContent = styled(Text)`
  font-size: 0.875rem;
`;

export const SubText = styled(Text)`
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0.0044rem;
`;

export const TextBold = styled(Text)`
  font-weight: 700;
`;

export const SubTextBold = styled(SubText)`
  font-weight: 700;
  line-height: 150%;
`;

export const BoldHeader1 = styled(Header1)`
  font-weight: 700;
  line-height: 1.875rem;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    font-size: 1.25rem;
  }
`;

export const BoldHeader2 = styled(Header2)`
  font-weight: 700;
  line-height: 150%;
`;

export const BoldHeader3 = styled(Header3)`
  font-weight: 700;
`;

export const MediumText = styled(Text)`
  font-weight: 500;
  font-size: 0.875rem;
`;
